export const BE_IMPORT_TASK_PROGRESS_MULTIPLIER = 6 / 4;
